import React from 'react';
import { graphql } from 'gatsby';
import Accordion from './Accordion';
import FeaturedResourceCta from './FeaturedResourceCta';
import CallToAction from './CallToAction';
import CallToActionStrip from './CallToActionStrip';
import Careers from './Careers';
import ContactForm from './ContactForm';
import ContainedImage from './ContainedImage';
import Content from './Content';
import ExternalVideo from './ExternalVideo';
import Faqs from './Faqs';
import FeaturedBlogPosts from './FeaturedBlogPosts';
import FeaturedCaseStudies from './FeaturedCaseStudies';
import FeaturedEbooks from './FeaturedEbooks';
import FeaturedLogos from './FeaturedLogos';
import FeaturedResource from './FeaturedResource';
import FeaturedResults from './FeaturedResults';
import FeaturedReviews from './FeaturedReviews';
import FeaturedStatistics from './FeaturedStatistics';
import FeaturedSteps from './FeaturedSteps';
import FeaturedTools from './FeaturedTools';
import FileDemos from './FileDemos';
import FullWidthImage from './FullWidthImage';
import HighlightedContent from './HighlightedContent';
import Html from './Html';
import IconContentBlocks from './IconContentBlocks';
import ImageContentBlocks from './ImageContentBlocks';
import ImageContentCards from './ImageContentCards';
import ImageContent from './ImageContent';
import InternalVideo from './InternalVideo';
import MapLocations from './MapLocations';
import NewsletterSignup from './NewsletterSignup';
import Plans from './Plans';
import Services from './Services';
import Table from './Table';
import Tabs from './Tabs';
import TeamProfiles from './TeamProfiles';
import Testimonial from './Testimonial';

const ModularBlocks = ({
  items,
  resource,
  isBlogDetail,
  isCaseStudyDetail,
  isSalesforceExplainerDetail,
}) =>
  items.map(item => (
    <React.Fragment key={item.id}>
      {item.model.apiKey === 'accordion_modular_block' && (
        <Accordion
          heading={item.heading}
          items={item.accordionItems}
          isFaqs={item.isFaqs}
          alt={item.altColour}
        />
      )}
      {item.model.apiKey === 'blog_featured_resource_modular_block' && (
        <FeaturedResourceCta {...resource} />
      )}
      {item.model.apiKey === 'call_to_action_modular_block' && (
        <CallToAction
          image={item.image}
          heading={item.heading}
          text={item.plainText}
          link={item.link}
        />
      )}
      {item.model.apiKey === 'call_to_action_strip_modular_block' && (
        <CallToActionStrip
          image={item.image}
          heading={item.heading}
          content={item.content}
          link={item.link}
          imageAbove={item.imageAbove}
        />
      )}
      {item.model.apiKey === 'careers_modular_block' && (
        <Careers heading={item.heading} text={item.text} />
      )}
      {item.model.apiKey === 'contact_form_modular_block' && (
        <ContactForm
          heading={item.heading}
          text={item.plainText}
          image={item.image}
          pardotFormUrl={item.pardotFormUrl}
          pardotFormHeight={item.pardotFormHeight}
          altBackground={item.altBackground}
        />
      )}
      {item.model.apiKey === 'contained_image_modular_block' && (
        <ContainedImage
          image={item.image}
          caption={item.caption}
          link={item.link}
          isBlogDetail={isBlogDetail}
          isCaseStudyDetail={isCaseStudyDetail}
        />
      )}
      {item.model.apiKey === 'contained_image_narrower_modular_block' && (
        <ContainedImage
          image={item.image}
          maxWidth={item.maxWidth}
          caption={item.caption}
          link={item.link}
          isBlogDetail={isBlogDetail}
          isSalesforceExplainerDetail={isSalesforceExplainerDetail}
        />
      )}
      {item.model.apiKey === 'content_modular_block' && (
        <Content
          heading={item.heading}
          content={item.content}
          centerAlignText={item.centerAlignText}
          twoColumns={item.twoColumns}
          highlight={item.highlight}
          contain={item.contain}
          isBlogDetail={isBlogDetail}
          isCaseStudyDetail={isCaseStudyDetail}
          isSalesforceExplainerDetail={isSalesforceExplainerDetail}
        />
      )}
      {item.model.apiKey === 'external_video_modular_block' && (
        <ExternalVideo
          heading={item.heading}
          video={item.externalVideo}
          isBlogDetail={isBlogDetail}
          isCaseStudyDetail={isCaseStudyDetail}
          isSalesforceExplainerDetail={isSalesforceExplainerDetail}
        />
      )}
      {item.model.apiKey === 'faqs_modular_block' && (
        <Faqs
          heading={item.heading}
          items={item.faqItems}
          image={item.image}
          alt={item.altColour}
        />
      )}
      {item.model.apiKey === 'featured_blog_posts_modular_block' && (
        <FeaturedBlogPosts
          heading={item.heading}
          subheading={item.subheading}
          items={item.blogPosts}
        />
      )}
      {item.model.apiKey === 'featured_case_studies_modular_block' && (
        <FeaturedCaseStudies
          heading={item.heading}
          text={item.text}
          items={item.caseStudies}
        />
      )}
      {item.model.apiKey === 'featured_ebooks_modular_block' && (
        <FeaturedEbooks heading={item.heading} items={item.ebooks} />
      )}
      {item.model.apiKey === 'featured_logos_modular_block' && (
        <FeaturedLogos
          heading={item.heading}
          text={item.text}
          items={item.logos}
        />
      )}
      {item.model.apiKey === 'featured_resource_modular_block' && (
        <FeaturedResource
          heading={item.heading}
          resource={item.featuredResource}
        />
      )}
      {item.model.apiKey === 'featured_results_modular_block' && (
        <FeaturedResults
          heading={item.heading}
          items={item.featuredResults}
          isCaseStudyDetail={isCaseStudyDetail}
        />
      )}
      {item.model.apiKey === 'featured_reviews_modular_block' && (
        <FeaturedReviews
          heading={item.heading}
          initialItems={item.reviews}
          link={item.link}
        />
      )}
      {item.model.apiKey === 'featured_statistics_modular_block' && (
        <FeaturedStatistics
          items={item.featuredStatistics}
          alt={item.altColour}
        />
      )}
      {item.model.apiKey === 'featured_steps_modular_block' && (
        <FeaturedSteps
          heading={item.heading}
          text={item.text}
          items={item.featuredSteps}
        />
      )}
      {item.model.apiKey === 'featured_tools_modular_block' && (
        <FeaturedTools heading={item.heading} items={item.tools} />
      )}
      {item.model.apiKey === 'file_demos_modular_block' && (
        <FileDemos
          heading={item.heading}
          text={item.text}
          items={item.fileDemos}
        />
      )}
      {item.model.apiKey === 'full_width_image_modular_block' && (
        <FullWidthImage image={item.image} />
      )}
      {item.model.apiKey === 'highlighted_content_modular_block' && (
        <HighlightedContent
          image={item.image}
          heading={item.heading}
          content={item.content}
          link={item.link}
        />
      )}
      {item.model.apiKey === 'html_modular_block' && (
        <Html html={item.html} isBlogDetail={isBlogDetail} />
      )}
      {item.model.apiKey === 'icon_content_blocks_modular_block' && (
        <IconContentBlocks
          heading={item.heading}
          items={item.iconContentBlocks}
        />
      )}
      {item.model.apiKey === 'image_content_blocks_modular_block_v1' && (
        <ImageContentBlocks
          heading={item.heading}
          text={item.text}
          items={item.imageContentBlocks}
          version={1}
        />
      )}
      {item.model.apiKey === 'image_content_blocks_modular_block_v2' && (
        <ImageContentBlocks
          heading={item.heading}
          text={item.text}
          items={item.imageContentBlocks}
          version={2}
        />
      )}
      {item.model.apiKey === 'image_content_cards_modular_block' && (
        <ImageContentCards
          heading={item.heading}
          text={item.text}
          items={item.imageContentCards}
          highlight={item.highlight}
        />
      )}
      {item.model.apiKey ===
        'image_content_cards_modular_block_illustration' && (
        <ImageContentCards
          heading={item.heading}
          text={item.text}
          items={item.imageContentCards}
          highlight={item.highlight}
        />
      )}
      {item.model.apiKey === 'image_content_modular_block_v1' && (
        <ImageContent
          image={item.image}
          heading={item.heading}
          text={item.text}
          link={item.link}
          flip={item.flip}
          testimonial={item.testimonial}
          version={1}
        />
      )}
      {item.model.apiKey === 'image_content_modular_block_illustration' && (
        <ImageContent
          image={item.image}
          heading={item.heading}
          text={item.text}
          link={item.link}
          flip={item.flip}
          testimonial={item.testimonial}
          version={1}
        />
      )}
      {item.model.apiKey === 'image_content_modular_block_v2' && (
        <ImageContent
          image={item.image}
          heading={item.heading}
          text={item.text}
          link={item.link}
          flip={item.flip}
          version={2}
        />
      )}
      {item.model.apiKey === 'internal_video_modular_block' && (
        <InternalVideo
          heading={item.heading}
          video={item.internalVideo}
          isBlogDetail={isBlogDetail}
          isCaseStudyDetail={isCaseStudyDetail}
          isSalesforceExplainerDetail={isSalesforceExplainerDetail}
        />
      )}
      {item.model.apiKey === 'map_locations_modular_block' && (
        <MapLocations
          heading={item.heading}
          text={item.text}
          items={item.mapLocations}
        />
      )}
      {item.model.apiKey === 'newsletter_signup_modular_block' && (
        <NewsletterSignup isBlogDetail={isBlogDetail} />
      )}
      {item.model.apiKey === 'plans_modular_block' && (
        <Plans heading={item.heading} items={item.plans} />
      )}
      {item.model.apiKey === 'services_modular_block' && (
        <Services heading={item.heading} text={item.text} video={item.video} />
      )}
      {item.model.apiKey === 'table_modular_block' && (
        <Table
          table={item.table}
          firstColumnOneLine={item.firstColumnOneLine}
          isBlogDetail={isBlogDetail}
        />
      )}
      {item.model.apiKey === 'tabs_modular_block' && (
        <Tabs heading={item.heading} items={item.tabs} />
      )}
      {item.model.apiKey === 'team_profiles_modular_block' && (
        <TeamProfiles heading={item.heading} text={item.text} />
      )}
      {item.model.apiKey === 'testimonial_modular_block' && (
        <Testimonial item={item.testimonial} />
      )}
    </React.Fragment>
  ));

export default ModularBlocks;

export const ModularBlockFragments = graphql`
  fragment AccordionModularBlockFragment on DatoCmsAccordionModularBlock {
    id
    model {
      apiKey
    }
    heading
    accordionItems {
      heading
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
    isFaqs
    altColour
  }

  fragment BlogFeaturedResourceModularBlockFragment on DatoCmsBlogFeaturedResourceModularBlock {
    id
    model {
      apiKey
    }
  }

  fragment CallToActionModularBlockFragment on DatoCmsCallToActionModularBlock {
    id
    model {
      apiKey
    }
    heading
    plainText: text
    image {
      url
      alt
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }

  fragment CallToActionStripModularBlockFragment on DatoCmsCallToActionStripModularBlock {
    id
    model {
      apiKey
    }
    image {
      url
      alt
    }
    heading
    content {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
    imageAbove
  }

  fragment CareersModularBlockFragment on DatoCmsCareersModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
  }

  fragment ContactFormModularBlockFragment on DatoCmsContactFormModularBlock {
    id
    model {
      apiKey
    }
    heading
    plainText: text
    image {
      url
      alt
    }
    pardotFormUrl
    pardotFormHeight
    altBackground
  }

  fragment ContainedImageModularBlockFragment on DatoCmsContainedImageModularBlock {
    id
    model {
      apiKey
    }
    image {
      gatsbyImageData(width: 1240)
      alt
    }
    caption
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }

  fragment ContainedImageNarrowerModularBlockFragment on DatoCmsContainedImageNarrowerModularBlock {
    id
    model {
      apiKey
    }
    image {
      gatsbyImageData(width: 900)
      alt
    }
    maxWidth
    caption
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }

  fragment ContentModularBlockFragment on DatoCmsContentModularBlock {
    id
    model {
      apiKey
    }
    heading
    content {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    centerAlignText
    twoColumns
    highlight
    contain
  }

  fragment ExternalVideoModularBlockFragment on DatoCmsExternalVideoModularBlock {
    id
    model {
      apiKey
    }
    heading
    externalVideo {
      height
      width
      provider
      providerUid
      url
    }
  }

  fragment FaqsModularBlockFragment on DatoCmsFaqsModularBlock {
    id
    model {
      apiKey
    }
    heading
    faqItems {
      heading
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
    image {
      url
      alt
    }
    altColour
  }

  fragment FeaturedBlogPostsModularBlockFragment on DatoCmsFeaturedBlogPostsModularBlock {
    id
    model {
      apiKey
    }
    heading
    subheading
    blogPosts {
      ...BlogCardFragment
    }
  }

  fragment FeaturedCaseStudiesModularBlockFragment on DatoCmsFeaturedCaseStudiesModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    caseStudies {
      ...CaseStudyCardFragment
    }
  }

  fragment FeaturedEbooksModularBlockFragment on DatoCmsFeaturedEbooksModularBlock {
    id
    model {
      apiKey
    }
    heading
    ebooks {
      ...EbookCardFragment
    }
  }

  fragment FeaturedLogosModularBlockFragment on DatoCmsFeaturedLogosModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    logos {
      format
      url
      gatsbyImageData(width: 180, height: 60)
      alt
    }
  }

  fragment FeaturedResourceModularBlockFragment on DatoCmsFeaturedResourceModularBlock {
    id
    model {
      apiKey
    }
    heading
    featuredResource {
      ...FeaturedResourceFragment
    }
  }

  fragment FeaturedReviewsModularBlockFragment on DatoCmsFeaturedReviewsModularBlock {
    id
    model {
      apiKey
    }
    heading
    reviews {
      ...ReviewCardFragment
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }

  fragment FeaturedResultsModularBlockFragment on DatoCmsFeaturedResultsModularBlock {
    id
    model {
      apiKey
    }
    heading
    featuredResults {
      result
      text
    }
  }

  fragment FeaturedStatisticsModularBlockFragment on DatoCmsFeaturedStatisticsModularBlock {
    id
    model {
      apiKey
    }
    featuredStatistics {
      statistic
      text
    }
    altColour
  }

  fragment FeaturedStepsModularBlockFragment on DatoCmsFeaturedStepsModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
    }
    featuredSteps {
      heading
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      image {
        url
        alt
      }
      link {
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
  }

  fragment FeaturedToolsModularBlockFragment on DatoCmsFeaturedToolsModularBlock {
    id
    model {
      apiKey
    }
    heading
    tools {
      ...ToolCardFragment
    }
  }

  fragment FileDemosModularBlockFragment on DatoCmsFileDemosModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    fileDemos {
      image {
        gatsbyImageData(width: 560, height: 300)
        alt
      }
      heading
      prices {
        gbPrice
        localePrices {
          locale
          price
        }
      }
      text
      file {
        url
      }
    }
  }

  fragment FullWidthImageModularBlockFragment on DatoCmsFullWidthImageModularBlock {
    id
    model {
      apiKey
    }
    image {
      gatsbyImageData(width: 2000, layout: FULL_WIDTH)
      alt
    }
  }

  fragment HighlightedContentModularBlockFragment on DatoCmsHighlightedContentModularBlock {
    id
    model {
      apiKey
    }
    image {
      url
      alt
    }
    heading
    content {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
  }

  fragment HtmlModularBlockFragment on DatoCmsHtmlModularBlock {
    id
    model {
      apiKey
    }
    html
  }

  fragment IconContentBlocksModularBlockFragment on DatoCmsIconContentBlocksModularBlock {
    id
    model {
      apiKey
    }
    heading
    iconContentBlocks {
      heading
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      icon {
        url
        alt
      }
    }
  }

  fragment ImageContentBlocksModularBlockV1Fragment on DatoCmsImageContentBlocksModularBlockV1 {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    imageContentBlocks {
      ...ImageContentModularBlockV1Fragment
      ...ImageContentModularBlockIllustrationFragment
    }
  }

  fragment ImageContentBlocksModularBlockV2Fragment on DatoCmsImageContentBlocksModularBlockV2 {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    imageContentBlocks {
      ...ImageContentModularBlockV2Fragment
    }
  }

  fragment ImageContentCardsModularBlockFragment on DatoCmsImageContentCardsModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    imageContentCards {
      image {
        gatsbyImageData(width: 710, height: 510)
        alt
      }
      heading
      text {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      link {
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    highlight
  }

  fragment ImageContentCardsModularBlockIllustrationFragment on DatoCmsImageContentCardsModularBlockIllustration {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    imageContentCards {
      image {
        url
        alt
        format
      }
      heading
      text {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      link {
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    highlight
  }

  fragment ImageContentModularBlockV1Fragment on DatoCmsImageContentModularBlockV1 {
    id
    model {
      apiKey
    }
    image {
      gatsbyImageData(width: 765, height: 640)
      alt
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
    testimonial {
      quote
      author
      role
    }
    flip
  }

  fragment ImageContentModularBlockIllustrationFragment on DatoCmsImageContentModularBlockIllustration {
    id
    model {
      apiKey
    }
    image {
      url
      alt
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
    testimonial {
      quote
      author
      role
    }
    flip
  }

  fragment ImageContentModularBlockV2Fragment on DatoCmsImageContentModularBlockV2 {
    id
    model {
      apiKey
    }
    image {
      gatsbyImageData(width: 930, height: 660)
      alt
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    link {
      text
      pageUrl {
        ...LinkFragment
      }
    }
    flip
  }

  fragment InternalVideoModularBlockFragment on DatoCmsInternalVideoModularBlock {
    id
    model {
      apiKey
    }
    heading
    internalVideo {
      format
      url
      video {
        thumbnailUrl
        mp4Url
      }
      title
    }
  }

  fragment MapLocationsModularBlockFragment on DatoCmsMapLocationsModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    mapLocations {
      name
      latitudePercentage
      longitudePercentage
      flag {
        url
        alt
      }
      link {
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
  }

  fragment NewsletterSignupModularBlockFragment on DatoCmsNewsletterSignupModularBlock {
    id
    model {
      apiKey
    }
  }

  fragment PlansModularBlockFragment on DatoCmsPlansModularBlock {
    id
    model {
      apiKey
    }
    heading
    plans {
      heading
      text
      link {
        text
        pageUrl {
          ...LinkFragment
        }
      }
      icon {
        url
        alt
      }
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
      prices {
        gbPrice
        localePrices {
          locale
          price
        }
      }
    }
  }

  fragment ServicesModularBlockFragment on DatoCmsServicesModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
    video {
      format
      url
      video {
        thumbnailUrl
        mp4Url
      }
      title
    }
  }

  fragment TableModularBlockFragment on DatoCmsTableModularBlock {
    id
    model {
      apiKey
    }
    table
    firstColumnOneLine
  }

  fragment TabsModularBlockFragment on DatoCmsTabsModularBlock {
    id
    model {
      apiKey
    }
    heading
    tabs {
      heading
      content {
        value
        links {
          id: originalId
          text
          pageUrl {
            ...LinkFragment
          }
        }
      }
    }
  }

  fragment TeamProfilesModularBlockFragment on DatoCmsTeamProfilesModularBlock {
    id
    model {
      apiKey
    }
    heading
    text {
      value
      links {
        id: originalId
        text
        pageUrl {
          ...LinkFragment
        }
      }
    }
  }

  fragment TestimonialModularBlockFragment on DatoCmsTestimonialModularBlock {
    id
    model {
      apiKey
    }
    testimonial {
      quote
      author
      role
      image {
        gatsbyImageData(width: 100, height: 100)
        alt
      }
    }
  }
`;
